export default __webpack_public_path__ + "static/media/lcs.88d94529.png";